import { filerScreenHelpers } from '@/mixins/filerScreen';
import { controlValueHelpers } from '@/mixins/controlValue';

export const pdfData = {
  name: 'PDFData',
  mixins: [
    filerScreenHelpers,
    controlValueHelpers,
  ],
  data() {
    return {
      pdf_currentFiling: null,
      pdfType: '',
      redactedFields: null,
    };
  },
  computed: {
    pdf_affiliationStatuses() {
      return this.cloneObj(this.$store.getters['admin/activeControlValues']('affiliationstatus'));
    },
    pdf_agencies() {
      return this.$store.getters['admin/activeControlValues']('agency');
    },
    pdf_states() {
      return this.$store.getters['admin/activeControlValues']('state');
    },
    pdf_filerStatus() {
      return this.cloneObj(this.$store.state.filing.currentFilerStatus);
    },
    pdf_positions() {
      return this.cloneObj(this.$store.state.filing.currentFilingPositions);
    },
    pdf_realEstate() {
      return this.cloneObj(this.$store.state.realEstate.realEstate);
    },
    pdf_creditors() {
      return this.cloneObj(this.$store.state.creditors.creditors);
    },
    pdf_loanAmounts() {
      return this.$store.getters['admin/activeControlValues']('loanamount');
    },
    pdf_incomeSources() {
      return this.cloneObj(this.$store.state.incomeSources.incomeSources);
    },
    pdf_incomeTypes() {
      return this.$store.getters['admin/activeControlValues']('incometype');
    },
    pdf_gifts() {
      return this.cloneObj(this.$store.state.gifts.gifts);
    },
    pdf_directorships() {
      return this.cloneObj(this.$store.state.directorships.directorships);
    },
    pdf_businessInterest() {
      return this.cloneObj(this.$store.state.businessInterest.businessInterests);
    },
    pdf_businessInterestTransfer() {
      return this.cloneObj(this.$store.state.businessInterestTransfer.businessInterestTransfers);
    },
    pdf_familyMembers() {
      return this.cloneObj(this.$store.state.family.familyMembers);
    },
    pdf_familyRelationships() {
      return this.$store.getters['admin/activeControlValues']('familymember');
    },
    filerProfile() {
      return this.$store.state.user.profile;
    },
  },
  methods: {
    getPdfFieldValue(section, id, fieldName, fieldValue) {
      if (this.redactFields) {
        if (section === 'filing') {
          if (this.redactFields['filing'].includes(fieldName) && fieldValue !== '') {
            return this.getRedactionByLength(fieldValue.toString().length);
          }
        } else {
          for (let redactedField in this.redactedFields[section]) {
            let currentField = this.redactedFields[section][redactedField];
            if (currentField.id === id && currentField.field === fieldName && fieldValue !== '') {
              return this.getRedactionByLength(fieldValue.toString().length);
            }
          }
        }
      }
      return fieldValue;
    },
    getRedactionByLength(length) {
      let char = 'X';
      let result = '';
      for (let i = 0; i < length && i < 10; i++) {
        result = result + char;
      }
      return result;
    },
    // pdfFields(section) {
    //   let fields = null;
    //   if (section === 'filing') {
    //     fields = [ this.cloneObj(this.pdf_currentFiling) ];
    //   } else {
    //     fields = this.cloneObj(this[`pdf_${section}`]);
    //   }

    //   if (this.redactedFields && this.redactedFields[section] && this.redactedFields[section].length > 0) {
    //     this.redactedFields[section].forEach(rField => {
    //       for (let i=0;i < fields.length; i++) {
    //         if (typeof rField !== 'string') {
    //           if (fields[i].id === rField.id) {
    //             fields[i][rField.field] = this.getRedactionByLength(fields[i][rField.field].length);
    //           }
    //         } else {
    //           fields[i][rField] = this.getRedactionByLength(fields[i][rField].length);
    //         }
    //       }
    //     });
    //   }

    //   if (section === 'filing') {
    //     fields = fields[0];
    //   }

    //   return fields;

    // },
    async pdf_getPdfData(type, filingId, draft, redactFields) {

      this.pdfType = type;
      this.redactedFields = redactFields;

      let isDraft = draft ? draft : false;

      await this.pdf_initialFetch(filingId);
      await this.pdf_initialAssign();

      let data = {
        filingId: this.pdf_currentFiling.id,
        year: Number(this.pdf_currentFiling.year),
        templateName: type,
        pdfFields: [],
        settings: {
          overWriteFile: true,
          WatermarkTemplateName: null,
        },
      };

      let newExtraData = [];

      let maxPositions = 0;
      let maxRealEstate = 0;
      let maxCreditors = 0;
      let maxIncomeSources = 0;
      let maxDirectorships = 0;
      let maxBusinessInt = 1;
      let maxBusinessIntTrans = 1;

      if (type === 'City') {
        maxPositions = 1;
        maxRealEstate = 1;
        maxCreditors = 1;
        maxIncomeSources = 3;
        maxDirectorships = 1;
      }
      if (type === 'Mayor') {
        maxPositions = 1;
        maxIncomeSources = 6;
        maxDirectorships = 6;
      }
      if (type === 'State') {
        maxPositions = 2;
        maxRealEstate = 1;
        maxCreditors = 1;
        maxIncomeSources = 1;
        maxDirectorships = 1;
      }

      let filing = this.pdf_currentFiling;

      data.pdfFields.push(
        {
          fieldName: "lastName",
          fieldValue: filing.lastName,
        },
        {
          fieldName: "firstName",
          fieldValue: filing.firstName,
        },
        {
          fieldName: "midInit",
          fieldValue: filing.midInit ? filing.midInit : '',
        },
        {
          fieldName: "suffix",
          fieldValue: filing.suffix ? filing.suffix : '',
        },
        {
          fieldName: "signature",
          fieldValue: 'COMPLETED AND SIGNED ELECTRONICALLY',
        },
        {
          fieldName: "date",
          fieldValue: this.formatDate(filing.completedDate, 'MM/DD/YYYY'),
        },
        {
          fieldName: "address",
          fieldValue: this.getPdfFieldValue('filing', '', 'homeStreetAddress', filing.homeStreetAddress),
        },
        {
          fieldName: "city",
          fieldValue: this.getPdfFieldValue('filing', '', 'homeCity', filing.homeCity),
        },
        {
          fieldName: "state",
          fieldValue: this.getPdfFieldValue('filing', '', 'homeState', this.getControlValue(filing.homeState, 'pdf_states')),
        },
        {
          fieldName: "zip",
          fieldValue: this.getPdfFieldValue('filing', '', 'homeZip', filing.homeZip),
        },
        {
          fieldName: "isAmendment",
          fieldValue: filing.filingStatus === 'AF' || filing.filingStatus === 'AP' ? "true" : '',
        },
        {
          fieldName: "year",
          fieldValue: filing.year,
        },
      );

      //POSITIONS
      let positions = this.pdf_getPositions(maxPositions);

      if (positions.positions.length > 0) {
        data.pdfFields.push(...positions.positions);
      }

      if (positions.extraPositions.length > 0) {
        newExtraData.push('---');
        newExtraData.push(...positions.extraPositions);
      }

      if (type === 'City' || type === 'State') {
        //REAL ESTATE
        let realEstate = this.pdf_getRealEstate(maxRealEstate, type);

        if (realEstate.realEstate.length > 0) {
          data.pdfFields.push(...realEstate.realEstate);
        }

        if (realEstate.extraRealEstate.length > 0) {
          newExtraData.push('---');
          newExtraData.push(...realEstate.extraRealEstate);
        }

        //CREDITORS
        let creditors = this.pdf_getCreditors(maxCreditors, type);

        if (creditors.creditors.length > 0) {
          data.pdfFields.push(...creditors.creditors);
        }

        if (creditors.extraCreditors.length > 0) {
          newExtraData.push('---');
          newExtraData.push(...creditors.extraCreditors);
        }

        //Income Sources
        let incomeSources = this.pdf_getIncomeSources(maxIncomeSources, type);

        if (incomeSources.incomeSources.length > 0) {
          data.pdfFields.push(...incomeSources.incomeSources);
        }

        if (incomeSources.extraIncomeSources.length > 0) {
          newExtraData.push('---');
          newExtraData.push(...incomeSources.extraIncomeSources);
        }

        //Business Interests
        let businessInt = this.pdf_getBusinessInt(maxBusinessInt, type);

        if (businessInt.businessInt.length > 0) {
          data.pdfFields.push(...businessInt.businessInt);
        }

        if (businessInt.extraBusinessInt.length > 0) {
          newExtraData.push('---');
          newExtraData.push(...businessInt.extraBusinessInt);
        }

      }

      //Directorships
      let directorships = this.pdf_getDirectorships(maxDirectorships, type);

      console.log("I am getting the directorships!");
      console.log(directorships.directorships.length + " directorships found.");
      if (directorships.directorships.length > 0) {
        console.log("Pushing directorships to pdfFields.");
        data.pdfFields.push(...directorships.directorships);
      }

      if (directorships.extraDirectorships.length > 0) {
        newExtraData.push('---');
        newExtraData.push(...directorships.extraDirectorships);
      }

      if (type === 'State') {

        let homePhone = this.getPdfFieldValue('filing', '', 'homePhone', filing.homePhone);

        data.pdfFields.push(
          {
            fieldName: "areaCode",
            fieldValue: homePhone ? homePhone.substring(0, 3) : '',
          },
          {
            fieldName: "phone",
            fieldValue: homePhone ? homePhone.substring(4, 12) : '',
          },
        );

        //Business Interests Transferred
        let businessIntTrans = this.pdf_businessIntTrans(maxBusinessIntTrans);

        if (businessIntTrans.businessIntTrans.length > 0) {
          data.pdfFields.push(...businessIntTrans.businessIntTrans);
        }

        if (businessIntTrans.extraBusinessIntTrans.length > 0) {
          newExtraData.push('---');
          newExtraData.push(...businessIntTrans.extraBusinessIntTrans);
        }

        //Gifts
        let gifts = this.pdf_getStateGifts();

        if (gifts.gifts.length > 0) {
          data.pdfFields.push(...gifts.gifts);
        }

        if (gifts.extraGifts.length > 0) {
          newExtraData.push('---');
          newExtraData.push(...gifts.extraGifts);
        }

        if (gifts.giftsTravel.length > 0) {
          data.pdfFields.push(...gifts.giftsTravel);
        }

        if (gifts.extraGiftsTravel.length > 0) {
          newExtraData.push('---');
          newExtraData.push(...gifts.extraGiftsTravel);
        }

        let statuses = this.pdf_getFilerStatuses();
        if (statuses.length > 0) {
          data.pdfFields.push(...statuses);
        }

        data.pdfFields.push({
          fieldName: "extras",
          fieldValue: "Some content",
        });

      }
      if (type === 'City') {

        data.pdfFields.push(
          {
            fieldName: "phone",
            fieldValue: this.getPdfFieldValue('filing', '', 'homePhone', filing.homePhone),
          },
        );

        //Gifts
        let gifts = this.pdf_getCityGifts();

        if (gifts.gifts.length > 0) {
          data.pdfFields.push(...gifts.gifts);
        }

        if (gifts.extraGifts.length > 0) {
          newExtraData.push('---');
          newExtraData.push(...gifts.extraGifts);
        }

        if (gifts.giftsHonoraria.length > 0) {
          data.pdfFields.push(...gifts.giftsHonoraria);
        }

        if (gifts.extraGiftsHonoraria.length > 0) {
          newExtraData.push('---');
          newExtraData.push(...gifts.extraGiftsHonoraria);
        }

      }
      if (type === 'Mayor') {

        let privateStreetAddress = this.getPdfFieldValue('filing', '', 'privateBusinessStreetAddress', filing.privateBusinessStreetAddress);

        let privateCity = this.getPdfFieldValue('filing', '', 'privateBusinessCity', filing.privateBusinessCity);

        let privateState = this.getPdfFieldValue('filing', '', 'privateBusinessState', filing.privateBusinessState);

        let privateZip = this.getPdfFieldValue('filing', '', 'privateBusinessZip', filing.privateBusinessZip);

        data.pdfFields.push(
          {
            fieldName: "businessAddress",
            fieldValue: this.pdf_getFullAddressStr(privateStreetAddress, privateCity, privateState, privateZip),
          },
        );

        //Family
        let family = this.pdf_getFamily();

        if (filing.mayorCertChosenOnline === 'A') {
          data.pdfFields.push({
            fieldName: "signature1",
            fieldValue: "COMPLETED AND SIGNED ELECTRONICALLY",
          });
          data.pdfFields.push({
            fieldName: "year1",
            fieldValue: filing.year.substring(2, 4),
          });
          data.pdfFields.push({
            fieldName: "date1",
            fieldValue: `${this.formatDate(filing.completedDate, 'MM/DD/YYYY')}`,
          });
        }

        if (filing.mayorCertChosenOnline === 'B') {
          data.pdfFields.push({
            fieldName: "signature2",
            fieldValue: "COMPLETED AND SIGNED ELECTRONICALLY",
          });
          data.pdfFields.push({
            fieldName: "year2",
            fieldValue: filing.year.substring(2, 4),
          });
          data.pdfFields.push({
            fieldName: "date2",
            fieldValue: `${this.formatDate(filing.completedDate, 'MM/DD/YYYY')}`,
          });
        }

        if (family.spouse.length > 0) {
          data.pdfFields.push(...family.spouse);
        }

        if (family.extraSpouse.length > 0) {
          newExtraData.push('---');
          newExtraData.push(...family.extraSpouse);
        }

        if (family.children.length > 0) {
          data.pdfFields.push(...family.children);
        }

        if (family.extraChildren.length > 0) {
          newExtraData.push('---');
          newExtraData.push(...family.extraChildren);
        }

        //Mayor Income Sources
        let incomeSources = this.pdf_getMayorIncomeSources();

        if (incomeSources.isSalary.length > 0) {
          data.pdfFields.push(...incomeSources.isSalary);
        }

        if (incomeSources.extraIsSalary.length > 0) {
          newExtraData.push('---');
          newExtraData.push(...incomeSources.extraIsSalary);
        }

        if (incomeSources.isProperty.length > 0) {
          data.pdfFields.push(...incomeSources.isProperty);
        }

        if (incomeSources.extraIsProperty.length > 0) {
          newExtraData.push('---');
          newExtraData.push(...incomeSources.extraIsProperty);
        }

        if (incomeSources.isInvestment.length > 0) {
          data.pdfFields.push(...incomeSources.isInvestment);
        }

        if (incomeSources.extraIsInvestment.length > 0) {
          newExtraData.push('---');
          newExtraData.push(...incomeSources.extraIsInvestment);
        }

        //Mayor Gifts
        let gifts = this.pdf_getMayorGifts();
        if (gifts.gifts.length > 0) {
          data.pdfFields.push(...gifts.gifts);
        }

        if (gifts.extraGifts.length > 0) {
          newExtraData.push('---');
          newExtraData.push(...gifts.extraGifts);
        }

      }

      data.pdfFields.forEach(field => {
        if (typeof field.fieldValue !== 'string') {
          field.fieldValue = String(field.fieldValue);
        }
      });

      let extraPages = this.arrayChunk(newExtraData, 55);

      if (extraPages.length > 0) {
        data['extraPages'] = [];
        extraPages.forEach((ep, pI) => {
          data['extraPages'].push({
            templateName: 'blank',
            pdfFields: [
              {
                fieldName: 'pageNumber',
                fieldValue: `Attachment Page ${pI + 1} of ${extraPages.length}`,
              },
              {
                fieldName: 'firstName',
                fieldValue: filing.firstName,
              },
              {
                fieldName: 'lastName',
                fieldValue: filing.lastName,
              },
              {
                fieldName: 'midInit',
                fieldValue: filing.midInit,
              },
              {
                fieldName: 'suffix',
                fieldValue: filing.suffix,
              },
              {
                fieldName: 'extras',
                fieldValue: ep.join('\n'),
              },
            ],
          });
        });
      }

      if (isDraft) {
        data.settings.WatermarkTemplateName = 'watermark';
        data.pdfFields.find(item => {
          if (item.fieldName === 'signature' || item.fieldName === 'signature1' || item.fieldName === 'signature2') {
            item.fieldValue = "DRAFT! NOT VALID AS AN OFFICIAL DOCUMENT";
          }
          if (item.fieldName === 'date' || item.fieldName === 'date1' || item.fieldName === 'date2') {
            item.fieldValue = "";
          }
        });
      }

      return data;
    },
    pdf_getFamily() {

      let familyMembers = this.pdf_familyMembers;

      let members = {
        spouse: [],
        extraSpouse: [],
        children: [],
        extraChildren: [],
      };

      let pushTo = 'spouse';
      let count = 1;
      let extraCount = 0;

      familyMembers.forEach(member => {
        //Spouse
        if (parseInt(member.type) === 10) {
          if (count > 1) {
            pushTo = 'extraSpouse';
            if (extraCount === 0) {
              members[pushTo].push(`Family/Spouse continuation`);
              members[pushTo].push(` `);
            }

            members[pushTo].push(`Name: ${this.getPdfFieldValue('familyMembers', member.id, 'name', member.name)}`);
            members[pushTo].push(`Occupation: ${this.getPdfFieldValue('familyMembers', member.id, 'occupation', member.occupation)}`);
            members[pushTo].push(' ');
            extraCount++;
          } else {
            members[pushTo].push({
              fieldName: `spouseNameOccupation${count}`,
              fieldValue: `${this.getPdfFieldValue('familyMembers', member.id, 'name', member.name)} ${member.occupation ? '-' : ''} ${this.getPdfFieldValue('familyMembers', member.id, 'occupation', member.occupation)}`,
            });
            count++;
          }
        }
      });

      pushTo = 'children';
      count = 1;
      extraCount = 0;

      familyMembers.forEach(member => {
        //Children
        if (parseInt(member.type) === 11) {
          if (count > 3) {
            pushTo = 'extraChildren';
            if (extraCount === 0) {
              members[pushTo].push(`Family/Children continuation`);
              members[pushTo].push(` `);
            }

            members[pushTo].push(`Name: ${this.getPdfFieldValue('familyMembers', member.id, 'name', member.name)}`);
            members[pushTo].push(`Occupation: ${this.getPdfFieldValue('familyMembers', member.id, 'occupation', member.occupation)}`);
            members[pushTo].push(' ');
            extraCount++;
          } else {
            members[pushTo].push({
              fieldName: `childNameOccupation${count}`,
              fieldValue: `${this.getPdfFieldValue('familyMembers', member.id, 'name', member.name)} ${member.occupation ? '-' : ''} ${this.getPdfFieldValue('familyMembers', member.id, 'occupation', member.occupation)}`,
            });
            count++;
          }
        }
      });

      return members;
    },
    pdf_getPositions(max) {

      let allPositions = this.pdf_positions;

      let positions = {
        positions: [],
        extraPositions: [],
      };

      allPositions.sort((a, b) => {
        if (a.primary === 'Y') {
          if (b.primary === 'Y') {
            return a.id - b.id;
          }
          return -1;
        }
        return a.id - b.id;
      });

      let pushTo = 'positions';
      let extraCount = 0;

      allPositions.forEach((position, index) => {

        let street = this.getPdfFieldValue('positions', position.id, 'streetAddress', position.streetAddress);

        let city = this.getPdfFieldValue('positions', position.id, 'city', position.city);

        let state = this.getPdfFieldValue('positions', position.id, 'state', position.state);

        let zip = this.getPdfFieldValue('positions', position.id, 'zip', position.zip);

        if (index >= max) {
          pushTo = 'extraPositions';
          if (extraCount === 0) {
            positions[pushTo].push(`Positions continuation`);
            positions[pushTo].push(` `);
          }

          positions[pushTo].push(`Public Position: ${this.getPdfFieldValue('positions', position.id, 'publicPosition', position.publicPosition)}`);

          positions[pushTo].push(`Affiliation Status: ${this.getPdfFieldValue('positions', position.id, 'affiliationStatus', this.getControlValueDesc(position.affiliationStatus, 'pdf_affiliationStatuses'))}`);

          positions[pushTo].push(`Governamental Entity: ${this.getPdfFieldValue('positions', position.id, 'agencyId', this.getControlValueDesc(position.agencyId, 'pdf_agencies'))}`);

          positions[pushTo].push(`Profession: ${this.getPdfFieldValue('positions', position.id, 'profession', position.profession)}`);
          positions[pushTo].push(`Address: ${this.pdf_getFullAddressStr(street, city, state, zip)}`);
          positions[pushTo].push(' ');
          extraCount++;
        } else {
          if (this.pdfType === 'City') {
            positions[pushTo].push({
              fieldName: `publicPosition${index + 1}`,
              fieldValue: `${this.getPdfFieldValue('positions', position.id, 'publicPosition', position.publicPosition)} (${this.getPdfFieldValue('positions', position.id, 'affiliationStatus', this.getControlValueDesc(position.affiliationStatus, 'pdf_affiliationStatuses'))})`,
            });
            positions[pushTo].push({
              fieldName: `affiliationStatus${index + 1}`,
              fieldValue: this.getPdfFieldValue('positions', position.id, 'affiliationStatus', this.getControlValueDesc(position.affiliationStatus, 'pdf_affiliationStatuses')),
            });
          } else {
            positions[pushTo].push({
              fieldName: `publicPosition${index + 1}`,
              fieldValue: this.getPdfFieldValue('positions', position.id, 'publicPosition', position.publicPosition),
            });
            positions[pushTo].push({
              fieldName: `affiliationStatus${index + 1}`,
              fieldValue: this.getPdfFieldValue('positions', position.id, 'affiliationStatus', this.getControlValue(position.affiliationStatus, 'pdf_affiliationStatuses')),
            });
          }
          positions[pushTo].push({
            fieldName: `agency${index + 1}`,
            fieldValue: this.getPdfFieldValue('positions', position.id, 'agencyId', this.getControlValueDesc(position.agencyId, 'pdf_agencies')),
          });
          positions[pushTo].push({
            fieldName: `profession${index + 1}`,
            fieldValue: this.getPdfFieldValue('positions', position.id, 'profession', position.profession),
          });

          let wStreet = this.getPdfFieldValue('positions', position.id, 'workStreetAddress', position.workStreetAddress);

          let wCity = this.getPdfFieldValue('positions', position.id, 'workCity', position.workCity);

          let wState = this.getPdfFieldValue('positions', position.id, 'workState', position.workState);

          let wZip = this.getPdfFieldValue('positions', position.id, 'workZip', position.workZip);

          positions[pushTo].push({
            fieldName: `positionAddress${index + 1}`,
            fieldValue: this.pdf_getFullAddressStr(wStreet, wCity, wState, wZip),
          });
        }

      });
      return positions;
    },
    pdf_getRealEstate(max) {

      let allRealEstate = this.pdf_realEstate;

      let realEstate = {
        realEstate: [],
        extraRealEstate: [],
      };

      let pushTo = 'realEstate';

      let extraCount = 0;
      allRealEstate.forEach((rs, index) => {
        if (index >= max) {
          pushTo = 'extraRealEstate';
          if (extraCount === 0) {
            realEstate[pushTo].push(`Real Estate continuation`);
            realEstate[pushTo].push(` `);
          }
          realEstate[pushTo].push(`Address: ${this.pdf_getFullAddressStr(rs.streetAddress, rs.city, rs.state, rs.zip)}`);
          realEstate[pushTo].push(`Nature: ${rs.nature}`);
          realEstate[pushTo].push(' ');
          extraCount++;
        } else {
          realEstate[pushTo].push({
            fieldName: `realEstateAddress${index + 1}`,
            fieldValue: this.pdf_getFullAddressStr(rs.streetAddress, rs.city, rs.state, rs.zip),
          });
          realEstate[pushTo].push({
            fieldName: `realEstateNature${index + 1}`,
            fieldValue: rs.nature,
          });
        }
      });

      if (allRealEstate.length === 0) {
        realEstate.realEstate.push({
          fieldName: 'noRealEstate',
          fieldValue: 'true',
        });
      }

      return realEstate;

    },
    pdf_getDirectorships(max, type) {
      let allDirectorships = this.pdf_directorships;

      let directorships = {
        directorships: [],
        extraDirectorships: [],
      };

      let pushTo = 'directorships';
      let extraCount = 0;
      let count = 1;

      allDirectorships.forEach(directorship => {
        let push = true;

        if (push) {
          if (count > max) {
            pushTo = 'extraDirectorships';
            if (extraCount === 0) {
              directorships[pushTo].push(`Directorship continuation`);
              directorships[pushTo].push(` `);
            }
            directorships[pushTo].push(`Name: ${directorship.name}`);
            if (type === 'State') {
              directorships[pushTo].push(`Address: ${this.pdf_getFullAddressStr(directorship.streetAddress, directorship.city, directorship.state, directorship.zip)}`);
            }
            /*
            if (type === "Mayor") {
              directorships[pushTo].push(`Person / Relationship: ${directorship.person === "9" ? 'You' : this.getControlValue(directorship.person, 'pdf_familyRelationships')}`);
            }*/
            directorships[pushTo].push(`Position: ${directorship.position}`);
            directorships[pushTo].push(' ');
            extraCount++;
          } else {
            if (type === 'State') {
              directorships[pushTo].push({
                fieldName: `directorshipAddress${count}`,
                fieldValue: this.pdf_getFullAddressStr(directorship.streetAddress, directorship.city, directorship.state, directorship.zip),
              });
              directorships[pushTo].push({
                fieldName: `directorshipName${count}`,
                fieldValue: directorship.name,
              });
              directorships[pushTo].push({
                fieldName: `directorshipPosition${count}`,
                fieldValue: directorship.position,
              });
            } else if (type === 'City') {
              directorships[pushTo].push({
                fieldName: `directorshipName${count}`,
                fieldValue: directorship.name,
              });
              directorships[pushTo].push({
                fieldName: `directorshipPosition${count}`,
                fieldValue: directorship.position,
              });
            } else if (type === 'Mayor') {

              directorships[pushTo].push({
                fieldName: `directorshipAddress${count}`,
                fieldValue: `${directorship.name} ${this.pdf_getFullAddressStr(directorship.streetAddress, directorship.city, directorship.state, directorship.zip)}`,
              });

              directorships[pushTo].push({
                fieldName: `directorshipDesc${count}`,
                fieldValue: directorship.nature,
              });

              directorships[pushTo].push({
                fieldName: `directorshipPosition${count}`,
                fieldValue: directorship.position,
              });
              /*
              directorships[pushTo].push({
                fieldName: `directorshipPerson${directorship.person}-${count}`,
                fieldValue: 'true',
              });*/
            }
            count++;
          }
        }

      });

      if (allDirectorships.length === 0) {
        directorships.directorships.push({
          fieldName: 'noDirectorships',
          fieldValue: 'true',
        });
      }

      return directorships;

    },
    pdf_getBusinessInt(max, type) {

      let allBusinessInterest = this.pdf_businessInterest;

      let businessInt = {
        businessInt: [],
        extraBusinessInt: [],
      };

      let pushTo = 'businessInt';
      let count = 1;

      let extraCount = 0;
      allBusinessInterest.forEach(bi => {
        let push = true;
        if (type === 'State' && bi.interestHeld <= 5) {
          push = false;
        }
        if (push) {
          if (count > max) {
            pushTo = 'extraBusinessInt';
            if (extraCount === 0) {
              businessInt[pushTo].push(`Business Interest continuation`);
              businessInt[pushTo].push(` `);
            }
            businessInt[pushTo].push(`Name: ${bi.name}`);
            if (type === 'State') {
              businessInt[pushTo].push(`Address: ${this.pdf_getFullAddressStr(bi.streetAddress, bi.city, bi.state, bi.zip)}`);
              businessInt[pushTo].push(`Interest Held: ${bi.interestHeld}%`);
            }
            businessInt[pushTo].push(' ');
            extraCount++;
          } else {
            if (type === 'State') {
              businessInt[pushTo].push({
                fieldName: `businessIntNameAddress${count}`,
                fieldValue: `${bi.name} - ${this.pdf_getFullAddressStr(bi.streetAddress, bi.city, bi.state, bi.zip)}`,
              });
              businessInt[pushTo].push({
                fieldName: `businessInterestHeld${count}`,
                fieldValue: `${bi.interestHeld}%`,
              });
            } else if (type === 'City') {
              businessInt[pushTo].push({
                fieldName: `businessInt${count}`,
                fieldValue: `${bi.name}`,
              });
            }
            count++;
          }
        }
      });

      if (allBusinessInterest.length === 0) {
        businessInt.businessInt.push({
          fieldName: 'noBusinessInt',
          fieldValue: 'true',
        });
      }

      return businessInt;

    },
    pdf_businessIntTrans(max) {

      let allBusinessInterestTransfer = this.pdf_businessInterestTransfer;

      let businessIntTrans = {
        businessIntTrans: [],
        extraBusinessIntTrans: [],
      };

      let pushTo = 'businessIntTrans';

      let extraCount = 0;
      allBusinessInterestTransfer.forEach((bi, index) => {
        if (index >= max) {
          pushTo = 'extraBusinessIntTrans';
          if (extraCount === 0) {
            businessIntTrans[pushTo].push(`Business Interest Transferred continuation`);
            businessIntTrans[pushTo].push(` `);
          }
          businessIntTrans[pushTo].push(`Name: ${bi.name}`);
          businessIntTrans[pushTo].push(`Address: ${this.pdf_getFullAddressStr(bi.streetAddress, bi.city, bi.state, bi.zip)}`);
          businessIntTrans[pushTo].push(`Transferee Name: ${bi.transfereeName}`);
          businessIntTrans[pushTo].push(`Transferee Relationship: ${bi.transfereeRelationship}`);
          businessIntTrans[pushTo].push(`Interest Held: ${bi.interestHeld}%`);
          businessIntTrans[pushTo].push(' ');
          extraCount++;
        } else {
          businessIntTrans[pushTo].push({
            fieldName: `businessIntAddress${index + 1}`,
            fieldValue: this.pdf_getFullAddressStr(bi.streetAddress, bi.city, bi.state, bi.zip),
          });
          businessIntTrans[pushTo].push({
            fieldName: `businessIntTransName${index + 1}`,
            fieldValue: `${bi.name}/${this.pdf_getFullAddressStr(bi.streetAddress, bi.city, bi.state, bi.zip)}`,
          });
          businessIntTrans[pushTo].push({
            fieldName: `businessIntTransferee${index + 1}`,
            fieldValue: `${bi.transfereeName}/${this.pdf_getFullAddressStr(bi.transfereeStreetAddress, bi.transfereeCity, bi.transfereeState, bi.transfereeZip)}`,
          });
          businessIntTrans[pushTo].push({
            fieldName: `businessIntTransInterestHeld${index + 1}`,
            fieldValue: `${bi.interestHeld}%`,
          });
          businessIntTrans[pushTo].push({
            fieldName: `businessIntTransRelationship${index + 1}`,
            fieldValue: `${bi.transfereeRelationship}`,
          });
          businessIntTrans[pushTo].push({
            fieldName: `businessIntTransDate${index + 1}`,
            fieldValue: `${this.formatDate(bi.transferDate, 'MM/DD/YYYY')}`,
          });
        }
      });

      if (allBusinessInterestTransfer.length === 0) {
        businessIntTrans[pushTo].push({
          fieldName: 'noBusinessIntTrans',
          fieldValue: 'true',
        });
      }

      return businessIntTrans;
    },
    pdf_getCreditors(max, type) {

      let allCreditors = this.pdf_creditors;

      let creditors = {
        creditors: [],
        extraCreditors: [],
      };

      let pushTo = 'creditors';

      let count = 1;
      let extraCount = 0;

      allCreditors.forEach(creditor => {
        let push = true;

        //State form: Only show option $6500 or more
        if (type === 'State') {
          if (parseInt(creditor.loanAmount) !== 50) {
            push = false;
          }
        }

        //City from: Don't push option $5,000 or less
        if (type === 'City') {
          if (parseInt(creditor.loanAmount) === 48) {
            push = false;
          }
        }

        if (count > max) {
          if (push) {
            pushTo = 'extraCreditors';
            if (extraCount === 0) {
              creditors[pushTo].push(`Creditors continuation`);
              creditors[pushTo].push(` `);
            }

            creditors[pushTo].push(`Name: ${creditor.name}`);
            creditors[pushTo].push(`Address: ${this.pdf_getFullAddressStr(creditor.streetAddress, creditor.city, creditor.state, creditor.zip)}`);
            creditors[pushTo].push(`Interest Rate: ${creditor.interestRate}%`);
            creditors[pushTo].push(' ');
            extraCount++;
          }
        } else {
          if (push) {
            creditors[pushTo].push({
              fieldName: `creditorName${count}`,
              fieldValue: creditor.name,
            });
            creditors[pushTo].push({
              fieldName: `creditorAddress${count}`,
              fieldValue: this.pdf_getFullAddressStr(creditor.streetAddress, creditor.city, creditor.state, creditor.zip),
            });
            creditors[pushTo].push({
              fieldName: `creditorInterestRate${count}`,
              fieldValue: `${creditor.interestRate}%`,
            });
            count++;
          }
        }
      });

      if (creditors.creditors.length === 0) {
        creditors.creditors.push({
          fieldName: 'noCreditors',
          fieldValue: 'true',
        });
      }

      return creditors;
    },
    pdf_getMayorIncomeSources() {

      let allIncomeSources = this.pdf_incomeSources;

      let incomeSources = {
        isSalary: [],
        extraIsSalary: [],
        isProperty: [],
        extraIsProperty: [],
        isInvestment: [],
        extraIsInvestment: [],
      };

      let pushTo = 'isSalary';
      let count = 1;
      let extraCount = 0;

      allIncomeSources.forEach(incomeSource => {

        let street = this.getPdfFieldValue('incomeSources', incomeSource.id, 'streetAddress', incomeSource.streetAddress);

        if (count > 6) {
          pushTo = 'extraIsSalary';
          if (parseInt(incomeSource.type) === 37) {
            if (extraCount === 0) {
              incomeSources[pushTo].push(`Income Sources: Salary, wages, and fee - continuation`);
              incomeSources[pushTo].push(` `);
            }

            incomeSources[pushTo].push(`Source/address: ${this.getPdfFieldValue('incomeSources', incomeSource.id, 'name', incomeSource.name)} - ${street}`);

            incomeSources[pushTo].push(`Nature of Business: ${this.getPdfFieldValue('incomeSources', incomeSource.id, 'natureofbusiness', incomeSource.natureofbusiness)}`);

            incomeSources[pushTo].push(`Nature of Service: ${this.getPdfFieldValue('incomeSources', incomeSource.id, 'natureOfIncome', incomeSource.natureOfIncome)}`);

            incomeSources[pushTo].push(`Amount: $${this.getPdfFieldValue('incomeSources', incomeSource.id, 'amount', incomeSource.amount)}`);

            incomeSources[pushTo].push(' ');
            extraCount++;
          }
        } else {
          if (parseInt(incomeSource.type) === 37) {
            incomeSources[pushTo].push({
              fieldName: `isSalaryAddress${count}`,
              fieldValue: `${this.getPdfFieldValue('incomeSources', incomeSource.id, 'name', incomeSource.name)} - ${street}`,
            });
            incomeSources[pushTo].push({
              fieldName: `isSalaryNatureOfBusiness${count}`,
              fieldValue: this.getPdfFieldValue('incomeSources', incomeSource.id, 'natureofbusiness', incomeSource.natureofbusiness),
            });
            incomeSources[pushTo].push({
              fieldName: `isSalaryNatureOfIncome${count}`,
              fieldValue: this.getPdfFieldValue('incomeSources', incomeSource.id, 'natureOfIncome', incomeSource.natureOfIncome),
            });
            incomeSources[pushTo].push({
              fieldName: `isSalaryAmount${count}`,
              fieldValue: `$${this.getPdfFieldValue('incomeSources', incomeSource.id, 'amount', incomeSource.amount)}`,
            });
            incomeSources[pushTo].push({
              fieldName: `isSalaryPerson${incomeSource.person}-${count}`,
              fieldValue: `true`,
            });
            count++;
          }
        }
      });

      pushTo = 'isProperty';
      count = 1;
      extraCount = 0;

      allIncomeSources.forEach(incomeSource => {

        let street = this.getPdfFieldValue('incomeSources', incomeSource.id, 'streetAddress', incomeSource.streetAddress);

        if (count > 6) {
          pushTo = 'extraIsProperty';
          if (parseInt(incomeSource.type) === 38) {
            if (parseInt(incomeSource.amount) >= 500) {
              if (extraCount === 0) {
                incomeSources[pushTo].push(`Income Sources: Property, Business, Partnership, Other - continuation`);
                incomeSources[pushTo].push(` `);
              }

              incomeSources[pushTo].push(`Source/address: ${this.getPdfFieldValue('incomeSources', incomeSource.id, 'name', incomeSource.name)} - ${street}`);

              incomeSources[pushTo].push(`Nature of Business: ${this.getPdfFieldValue('incomeSources', incomeSource.id, 'natureofbusiness', incomeSource.natureofbusiness)}`);

              incomeSources[pushTo].push(`Amount: $${this.getPdfFieldValue('incomeSources', incomeSource.id, 'amount', incomeSource.amount)}`);

              incomeSources[pushTo].push(' ');
              extraCount++;
            }
          }
        } else {
          if (parseInt(incomeSource.type) === 38) {
            if (parseInt(incomeSource.amount) >= 500) {

              incomeSources[pushTo].push({
                fieldName: `isPropertyNatureOfBusiness${count}`,
                fieldValue: this.getPdfFieldValue('incomeSources', incomeSource.id, 'natureofbusiness', incomeSource.natureofbusiness),
              });

              incomeSources[pushTo].push({
                fieldName: `isPropertyAmount${count}`,
                fieldValue: `$${this.getPdfFieldValue('incomeSources', incomeSource.id, 'amount', incomeSource.amount)}`,
              });

              incomeSources[pushTo].push({
                fieldName: `isPropertyAddress${count}`,
                fieldValue: `${this.getPdfFieldValue('incomeSources', incomeSource.id, 'name', incomeSource.name)} - ${street}`,
              });

              count++;
            }
          }
        }
      });

      pushTo = 'isInvestment';
      count = 1;
      extraCount = 0;

      allIncomeSources.forEach(incomeSource => {

        let street = this.getPdfFieldValue('incomeSources', incomeSource.id, 'streetAddress', incomeSource.streetAddress);

        if (count > 5) {
          pushTo = 'extraIsInvestment';
          if (parseInt(incomeSource.type) === 39 && incomeSource.incomeGain === 'Y' && parseInt(incomeSource.amount) > 500) {
            if (extraCount === 0) {
              incomeSources[pushTo].push(`Income Sources: Gains on property or investments - continuation`);
              incomeSources[pushTo].push(` `);
            }

            incomeSources[pushTo].push(`Source/address: ${this.getPdfFieldValue('incomeSources', incomeSource.id, 'name', incomeSource.name)} - ${street}`);

            incomeSources[pushTo].push(`Amount of Gain: $${this.getPdfFieldValue('incomeSources', incomeSource.id, 'amount', incomeSource.amount)}`);
            incomeSources[pushTo].push(' ');
            extraCount++;
          }
        } else {
          if (parseInt(incomeSource.type) === 39 && incomeSource.incomeGain === 'Y' && parseInt(incomeSource.amount) > 500) {
            incomeSources[pushTo].push({
              fieldName: `isInvestmentName${count}`,
              fieldValue: this.getPdfFieldValue('incomeSources', incomeSource.id, 'name', incomeSource.name),
            });
            incomeSources[pushTo].push({
              fieldName: `isInvestmentIncomeGain${count}`,
              fieldValue: `$${this.getPdfFieldValue('incomeSources', incomeSource.id, 'amount', incomeSource.amount)}`,
            });
            count++;
          }
        }
      });

      if (incomeSources.isSalary.length === 0) {
        incomeSources.isSalary.push({
          fieldName: 'noIsSalary',
          fieldValue: 'true',
        });
      }

      if (incomeSources.isProperty.length === 0) {
        incomeSources.isProperty.push({
          fieldName: 'noIsProperty',
          fieldValue: 'true',
        });
      }

      if (incomeSources.isInvestment.length === 0) {
        incomeSources.isInvestment.push({
          fieldName: 'noIsInvestment',
          fieldValue: 'true',
        });
      }

      return incomeSources;

    },

    //City & State forms only
    pdf_getIncomeSources(max, type) {

      let allIncomeSources = this.pdf_incomeSources;

      let incomeSources = {
        incomeSources: [],
        extraIncomeSources: [],
      };

      let count = 1;
      let extraCount = 0;

      allIncomeSources.forEach(incomeSource => {
        let pushTo = 'incomeSources';
        let push = true;
        let showIncomeAmount = false;

        //State form: Only show items with amount greater than 1300
        if (type === 'State') {
          if (incomeSource.amount <= 1300) {
            push = false;
          }
        }

        if (type === 'City') {
          //City: Only show items with amount greater or equal to 500
          if (incomeSource.amount < 500) {
            push = false;
          }
          //Update in 2023 filing for 2022: Show the actual amount if item is > 5000 and the user is a city employee/official
          if (this.pdf_currentFiling.year >= 2021) {
            if (incomeSource.amount > 5000 && this.pdf_currentFiling.isCityEmployee === true) {
              showIncomeAmount = true;
            }
          }
        }

        let street, city, state, zip, amount;

        if (push) {
          street = this.getPdfFieldValue('incomeSources', incomeSource.id, 'streetAddress', incomeSource.streetAddress);

          city = this.getPdfFieldValue('incomeSources', incomeSource.id, 'city', incomeSource.city);

          state = this.getPdfFieldValue('incomeSources', incomeSource.id, 'state', incomeSource.state);

          zip = this.getPdfFieldValue('incomeSources', incomeSource.id, 'zip', incomeSource.zip);

          amount = this.getPdfFieldValue('incomeSources', incomeSource.id, 'amount', incomeSource.amount);
        }

        //If item has amount, push it to the extra page too
        if (count > max || showIncomeAmount) {
          if (push) {
            pushTo = 'extraIncomeSources';
            if (extraCount === 0) {
              incomeSources[pushTo].push(`Income Sources continuation`);
              incomeSources[pushTo].push(` `);
            }
            incomeSources[pushTo].push(`Name: ${incomeSource.name}`);
            incomeSources[pushTo].push(`Address: ${this.pdf_getFullAddressStr(street, city, state, zip)}`);
            if (showIncomeAmount) {
              incomeSources[pushTo].push(`Amount: $${amount}`);
            }
            incomeSources[pushTo].push(' ');

            extraCount++;
          }
        } else {
          if (push) {
            incomeSources[pushTo].push({
              fieldName: `incomeSourceAddress${count}`,
              fieldValue: this.pdf_getFullAddressStr(street, city, state, zip),
            });
            incomeSources[pushTo].push({
              fieldName: `incomeSourceName${count}`,
              fieldValue: this.getPdfFieldValue('incomeSources', incomeSource.id, 'name', incomeSource.name),
            });

            count++;
          }
        }

      });

      //If income source needs to display amount it's thrown in the extra page
      //If there are no income sources that don't need the amount but there are some in the extra page
      //Show this message
      if (count === 1 && extraCount > 0) {
        incomeSources['incomeSources'].push({
          fieldName: `incomeSourceName${count}`,
          fieldValue: 'See extra page for more details',
        });
      }

      if (incomeSources.incomeSources.length === 0 && incomeSources.extraIncomeSources.length === 0) {
        incomeSources.incomeSources.push({
          fieldName: 'noIncomeSources',
          fieldValue: 'true',
        });
      }

      return incomeSources;
    },
    addExtraGift(gift, extraCount, prefix, sectionTitle) {
      let giftParts = [];
      //If is the first entry on the extra page, then print the section name first
      if (extraCount === 0) {
        giftParts.push(sectionTitle);
        giftParts.push(` `);
      }

      giftParts.push(`Source: ${gift.source}`);
      giftParts.push(`Address: ${this.pdf_getFullAddressStr(gift.streetAddress, gift.city, gift.state, gift.zip)}`);
      if (prefix !== 'Travel' || prefix !== 'Honoraria') {
        giftParts.push(`Description: ${gift.description}`);
        giftParts.push(`Reason: ${gift.reason}`);
      }
      if (prefix !== 'Honoraria') {
        giftParts.push(`Value: $${gift.value}`);
      }
      if (this.pdfType === 'Mayor') {
        giftParts.push(`Person / Relationship: ${gift.person === "9" ? 'You' : this.getControlValue(gift.person, 'pdf_familyRelationships')}`);
      }
      giftParts.push(' ');
      return giftParts;
    },
    addGift(gift, count, prefix) {

      let giftParts = [];
      let rd = [];
      rd.push(gift.reason);
      rd.push(gift.description);

      giftParts.push({
        fieldName: `gift${prefix}Source${count}`,
        fieldValue: gift.source,
      });
      giftParts.push({
        fieldName: `gift${prefix}Description${count}`,
        fieldValue: rd.join(' | '),
      });

      if (this.pdfType === 'State') {
        if (count === 1 && prefix === 'Travel') {
          giftParts.push({
            fieldName: `gift${prefix}Address${count}`,
            fieldValue: 'See overflow page',
          });
          giftParts.push({
            fieldName: `gift${prefix}Value${count}`,
            fieldValue: '',
          });
          giftParts.push({
            fieldName: `gift${prefix}ValueDecimal${count}`,
            fieldValue: '',
          });
        } else {

          giftParts.push({
            fieldName: `gift${prefix}Address${count}`,
            fieldValue: this.pdf_getFullAddressStr(gift.streetAddress, gift.city, gift.state, gift.zip),
          });

          //Gifts have a specific field for decimals
          let giftValue = gift.value.toString().split('.');

          //If whole value, add 00 as decimal for pdf form's sake
          let giftValueDecimal = giftValue[1] ? giftValue : '00';

          giftParts.push({
            fieldName: `gift${prefix}Value${count}`,
            fieldValue: `${giftValue}`,
          });
          giftParts.push({
            fieldName: `gift${prefix}ValueDecimal${count}`,
            fieldValue: giftValueDecimal,
          });
        }
      } else if (this.pdfType === 'City' || this.pdfType === 'Mayor') {
        giftParts.push({
          fieldName: `gift${prefix}Address${count}`,
          fieldValue: this.pdf_getFullAddressStr(gift.streetAddress, gift.city, gift.state, gift.zip),
        });
        giftParts.push({
          fieldName: `gift${prefix}Value${count}`,
          fieldValue: `$${gift.value}`,
        });
      }
      if (this.pdfType === 'Mayor') {
        giftParts.push({
          fieldName: `giftPerson${gift.person}-${count}`,
          fieldValue: `true`,
        });
      }

      return giftParts;
    },
    pdf_getStateGifts() {

      let allGifts = this.pdf_gifts;

      let gifts = {
        gifts: [],
        extraGifts: [],
        giftsTravel: [],
        extraGiftsTravel: [],
      };

      //State form separates gifts between two categories
      //Gifts + Honararium and H/T/L (travel)

      //First Category
      let count = 1;
      let extraCount = 0;

      allGifts.forEach(gift => {

        let push = true;

        let pushTo = 'gifts';
        //Gift type = Gift (12) OR Honorarium (13)
        if (push && parseInt(gift.type) !== 14) {
          //State form only shows gits with value >= to $250
          if (gift.value >= 250) {
            //State form only has space for one entry
            //All other entries will be added on a blank page
            if (count > 1) {
              pushTo = 'extraGifts';
              gifts[pushTo].push(...this.addExtraGift(gift, extraCount, '', 'Gifts continuation'));
              extraCount++;
            } else {
              if (gift.value > 9999.99) {
                pushTo = 'extraGifts';
                gifts[pushTo].push(...this.addExtraGift(gift, extraCount, '', 'Gifts continuation'));
                extraCount++;
              } else {
                gifts[pushTo].push(...this.addGift(gift, count, ''));
                count++;
              }
            }
          }
        }
      });

      //Second Category
      count = 1;
      extraCount = 0;

      allGifts.forEach(gift => {
        let push = true;

        let pushTo = 'giftsTravel';
        //Gift type = T/L/H (14)
        if (push && parseInt(gift.type) === 14) {
          //State form only shows gits with value > to $650
          if (gift.value > 650) {
            //State form only has space for one entry
            //All other entries will be added on a blank page

            if (count === 1) {
              gifts[pushTo].push(...this.addGift(gift, count, 'Travel'));
            }
            count++;

            pushTo = 'extraGiftsTravel';
            gifts[pushTo].push(...this.addExtraGift(gift, extraCount, 'Travel', 'Transportation, Lodging, Hospitality continuation'));
            extraCount++;

          }
        }
      });

      //Check if we have any items in each category, otherwise check nothing to report box
      if (gifts.gifts.length === 0) {
        gifts.gifts.push({
          fieldName: 'noGifts',
          fieldValue: 'true',
        });
      }

      if (gifts.giftsTravel.length === 0) {
        gifts.giftsTravel.push({
          fieldName: 'noGiftsTravel',
          fieldValue: 'true',
        });
      }

      return gifts;
    },
    pdf_getCityGifts() {

      let allGifts = this.pdf_gifts;

      let gifts = {
        gifts: [],
        extraGifts: [],
        giftsHonoraria: [],
        extraGiftsHonoraria: [],
      };

      //City form separates gifts between two categories
      //Gifts + H/T/L and Honararium

      //First Category
      let pushTo = 'gifts';
      let count = 1;
      let extraCount = 0;

      allGifts.forEach(gift => {

        let push = true;

        //Gift type = Gift (11) OR T/L/H (14)
        if (push && parseInt(gift.type) !== 13) {
          //City form only shows gits with value >= to $200
          if (gift.value >= 200) {
            //City form only has space for one entry
            //All other entries will be added on a blank page
            if (count > 1) {
              pushTo = 'extraGifts';
              gifts[pushTo].push(...this.addExtraGift(gift, extraCount, '', 'Gifts continuation'));
              extraCount++;
            } else {
              gifts[pushTo].push(...this.addGift(gift, count, ''));
              count++;
            }
          }
        }
      });

      //Second Category
      pushTo = 'giftsHonoraria';
      count = 1;
      extraCount = 0;

      allGifts.forEach(gift => {
        let push = true;

        //Gift type = Honorarium (13)
        if (push && parseInt(gift.type) === 13) {
          //City form only shows gits with value > to $100
          if (gift.value > 100) {
            //City form only has space for one entry
            //All other entries will be added on a blank page
            if (count > 1) {
              pushTo = 'extraGiftsHonoraria';
              gifts[pushTo].push(...this.addExtraGift(gift, extraCount, 'Honoraria', 'Honorarium continuation'));
              extraCount++;
            } else {
              gifts[pushTo].push(...this.addGift(gift, count, 'Honoraria'));
              count++;
            }
          }
        }
      });

      //Check if we have any items in each category, otherwise check nothing to report box
      if (gifts.gifts.length === 0) {
        gifts.gifts.push({
          fieldName: 'noGifts',
          fieldValue: 'true',
        });
      }

      if (gifts.giftsHonoraria.length === 0) {
        gifts.giftsHonoraria.push({
          fieldName: 'noGiftsHonoraria',
          fieldValue: 'true',
        });
      }

      return gifts;
    },
    pdf_getMayorGifts() {

      let allGifts = this.pdf_gifts;

      let gifts = {
        gifts: [],
        extraGifts: [],
      };

      let pushTo = 'gifts';
      let count = 1;
      let extraCount = 0;

      allGifts.forEach(gift => {
        //Mayor form only shows gits with value >= to $200
        if (gift.value >= 200) {
          //Mayor form has space for 5 entries
          //All other entries will be added on a blank page
          if (count > 5) {
            pushTo = 'extraGifts';
            gifts[pushTo].push(...this.addExtraGift(gift, extraCount, '', 'Gifts continuation'));
            extraCount++;
          } else {
            gifts[pushTo].push(...this.addGift(gift, count, 'Honoraria'));
            count++;
          }
        }
      });

      //Check if we have any items in each category, otherwise check nothing to report box
      if (allGifts.length === 0) {
        gifts.gifts.push({
          fieldName: 'noGifts',
          fieldValue: 'true',
        });
      }

      return gifts;
    },
    pdf_getFullAddressStr(street, city, state, zip) {
      let address = [];
      if (street) {
        address.push(`${street}`);
      }
      if (city) {
        address.push(`, ${city}`);
      }
      if (state) {
        address.push(`, ${this.getControlValue(state, 'pdf_states')}`);
      }
      if (zip) {
        address.push(` - ${zip}`);
      }
      return address.join('');
    },
    pdf_getFilerStatuses() {
      let statuses = [];
      this.pdf_filerStatus.forEach(status => {
        statuses.push({
          fieldName: status.statuses,
          fieldValue: "true",
        });
      });
      return statuses;
    },
    pdf_fillPdf() {
      this.$store.dispatch('filing/getPdf', this.pdfData).then(() => {
      });
    },

    async pdf_initialAssign() {
      this.pdf_currentFiling = this.cloneObj(this.$store.state.filing.filing);
    },

    async pdf_initialFetch(filingId) {
      let promises = [];
      if (!filingId) {
        await this.$store.dispatch('filing/checkCurrentFilingId');
      } else {
        this.$store.commit('filing/setCurrentFilingId', filingId);
      }

      promises.push(this.$store.dispatch('filing/fetchFiling'));
      promises.push(this.$store.dispatch('admin/getControlValue', 'agency'));
      promises.push(this.$store.dispatch('admin/getControlValue', 'state'));
      promises.push(this.$store.dispatch('admin/getControlValue', 'affiliationstatus'));
      promises.push(this.$store.dispatch('filing/fetchCurrentFilingFilerStatus'));
      promises.push(this.$store.dispatch('filing/fetchCurrentFilingPositions'));
      promises.push(this.$store.dispatch('realEstate/fetchRealEstate'));
      promises.push(this.$store.dispatch('creditors/fetchCreditors'));
      promises.push(this.$store.dispatch('admin/getControlValue', 'loanamount'));
      promises.push(this.$store.dispatch('incomeSources/fetchIncomeSources'));
      promises.push(this.$store.dispatch('gifts/fetchGifts'));
      promises.push(this.$store.dispatch('businessInterest/fetchBusinessInterests'));
      promises.push(this.$store.dispatch('businessInterestTransfer/fetchBusinessInterestsTransferred'));
      promises.push(this.$store.dispatch('directorships/fetchDirectorships'));
      promises.push(this.$store.dispatch('admin/getControlValue', 'incometype'));
      promises.push(this.$store.dispatch('admin/getControlValue', 'familymember'));
      promises.push(this.$store.dispatch('family/fetchFamilyMembers'));
      await Promise.all(promises);
    },
    arrayChunk(array, size) {
      const chunked_arr = [];
      let index = 0;
      while (index < array.length) {
        chunked_arr.push(array.slice(index, size + index));
        index += size;
      }
      return chunked_arr;
    },
  },
};
